import { ProviderType } from "@/types/ProviderConfig"
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import { API_URL, QUERY_KEYS } from "../constants"
import { IProviderConfig } from "../types/ProviderConfig"

export const useGetProviderConfig = (orgId: string, provider: ProviderType, token: string) =>
  useQuery<IProviderConfig, Error>({
    queryKey: QUERY_KEYS.providerConfig(orgId, provider),
    queryFn: async () => {
      const res = await fetch(`${API_URL}/organizations/${orgId}/provider-configs/${provider}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
      if (!res.ok) {
        const parsed = await res.json()
        throw new Error(parsed.error ?? parsed.message ?? parsed ?? "Internal Server Error")
      }
      const json = await res.json()
      if (json.error) {
        throw new Error(json.error)
      }
      return json
    },
  })

export const useUpsertProviderConfig = (orgId: string, provider: ProviderType, token: string) => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (config: any) => {
      const res = await fetch(`${API_URL}/organizations/${orgId}/provider-configs`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(config),
      })
      if (!res.ok) {
        const parsed = await res.json()
        throw new Error(parsed.error ?? parsed.message ?? parsed ?? "Internal Server Error")
      }
      return res.json()
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: QUERY_KEYS.providerConfig(orgId, provider) })
    },
  })
}
